import Vue from 'vue'
import { Breadcrumb, Spin, message } from 'ant-design-vue'
import SideMenu from './components/menu'
import './css/index.less'

Vue.use(Breadcrumb)
Vue.use(Spin)
Vue.use(SideMenu)
Vue.prototype.$message = message
